<script>
export default {
  props: {
    convenio: { type: Object },
  },
  computed: {
    isPrivate() {
      return this.convenio?.is_private === true || this.convenio?.is_private === 1
    },
  },
}
</script>

<template>
<div class="convenio">
  <p>ID: {{ convenio.id }}</p>
  <p>Nome: {{ convenio.name }}</p>
  <p>Particular: {{ isPrivate ? 'Sim' : 'Não' }}</p>
  <p v-if="convenio.code_tax_id">Código fiscal padrão: {{ convenio.code_tax_id }}</p>
  <p>Mostrar paciente no relatório NFS-e: {{ convenio.is_pacient_view ? 'Sim' : 'Não' }}</p>

  <div v-if="!isPrivate" class="mt-3">
    <h6>Dados NFS-e (tomador)</h6>
    <p>CNPJ: {{ convenio.cnpj || '-' }}</p>
    <p>E-mail: {{ convenio.email || '-' }}</p>
    <p>CEP: {{ convenio.cep || '-' }}</p>
    <p>Endereço: {{ convenio.logradouro || '-' }}, {{ convenio.numero || '-' }}</p>
    <p>Complemento: {{ convenio.complemento || '-' }}</p>
    <p>Bairro: {{ convenio.bairro || '-' }}</p>
    <p>UF: {{ convenio.uf || '-' }}</p>
    <p>Código município IBGE: {{ convenio.codigo_municipio || '-' }}</p>
  </div>

  <p class="mt-3">Criado: <b-badge data-name="created_at" class="field-created_at" variant="secondary">{{ convenio.created_at }}</b-badge></p>
  <p>Última alteração: <b-badge data-name="updated_at" class="field-updated_at" variant="secondary">{{ convenio.updated_at }}</b-badge></p>
</div>
</template>
